import { useEffect, useState } from "react";
import ImageScrollGallery from "../components/ImageScrollGallery";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faImage } from "@fortawesome/free-solid-svg-icons";
import {formatJournalPath} from "../utils/formatJournalPath";
import { fetchJson } from "../utils/fetchJson";
const JournalsPage = () => {
  const [journals, setJournals] = useState([]);
  const [isLoading, setIsLoading] = useState(true); // 新增加载状态
  const [error, setError] = useState(null); // 新增错误状态

  useEffect(() => {
    fetchJournals();
  }, []);

  const fetchJournals = () => {
    setIsLoading(true); // 开始加载时设置为true
    setError(null); // 重置错误状态

    fetchJson("/json/journals.json")
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to fetch journals");
        }
        return response.json();
      })
      .then((data) => {
        const newJournals = [
          ...data.journals,
          {
            id: "coming-soon",
            title: "More Journals Coming Soon",
            isComingSoon: true,
          },
        ];
        setJournals(newJournals); // 使用新数组更新状态
        setIsLoading(false); // 加载完成后设置为false
      })
      .catch((error) => {
        console.error("Error loading journals.json:", error);
        setError(error.message); // 设置错误信息
        setIsLoading(false); // 加载失败也设置为false
      });
  };

  // 加载状态显示
  if (isLoading) {
    return (
      <div className="container mt-4">
        <div className="d-flex justify-content-center align-items-center min-vh-50">
          <div className="text-center">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="mt-3 text-muted">Loading journals, please wait...</p>
          </div>
        </div>
      </div>
    );
  }

  // 错误状态显示
  if (error) {
    return (
      <div className="container mt-4">
        <div className="alert alert-danger text-center mt-5" role="alert">
          <h4 className="alert-heading">Error Loading Journals</h4>
          <p>{error}</p>
          <button className="btn btn-primary mt-3" onClick={fetchJournals}>
            Try Again
          </button>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="page-title">
        <h1>Explore Our Journals</h1>
      </div>

      {/* 期刊卡片列表 */}
      <div className="row">
        {journals.map((journal) => (
          <div key={journal.id} className="col-md-4 mb-4">
            {journal.isComingSoon ? (
              // 即将推出的期刊不添加链接
              <div className="card h-100 shadow-sm hover:shadow-md transition-shadow duration-300">
                <div className="bg-gray-100">
                  <div
                    style={{
                      height: "300px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      padding: "1rem",
                    }}
                  >
                    <div className="text-center">
                      <div
                        style={{
                          fontSize: "5rem",
                          marginBottom: "1rem",
                          color: "#6c757d",
                        }}
                      >
                        ...
                      </div>
                      <p className="text-muted">More Journal</p>
                    </div>
                  </div>
                </div>
                <div className="card-body d-flex justify-center align-items-center p-4">
                  <h5 className="card-title text-center">{journal.title}</h5>
                </div>
              </div>
            ) : (
              // 正常期刊用a标签包裹整个卡片
              <a
                href={`journal/${formatJournalPath(journal.title)}`}
                className="text-decoration-none text-dark"
              >
                <div className="card h-100 shadow-sm hover:shadow-md transition-shadow duration-300">
                  <div className="bg-gray-100">
                    {journal.img ? (
                      <img
                        src={journal.img}
                        className="card-img-top"
                        alt={journal.title}
                        style={{
                          objectFit: "contain",
                          maxHeight: "300px",
                          margin: "0 auto",
                        }}
                      />
                    ) : (
                      // 当图片路径无效时显示的替代内容
                      <div
                        style={{
                          height: "300px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          padding: "1rem",
                          color: "#6c757d",
                        }}
                      >
                        <FontAwesomeIcon
                          icon={faImage}
                          size="3x"
                          className="image-icon"
                        />
                      </div>
                    )}
                  </div>
                  <div className="card-body d-flex justify-center align-items-center p-4">
                    <h5 className="card-title text-center">{journal.title}</h5>
                  </div>
                </div>
              </a>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default JournalsPage;
